import React, { useEffect, useState } from 'react';
import DualColorDivider from '../../shared/dualColorDivider/DualColorDivider';
import './discoverSection.scss';
import SubTitle from '../../shared/subTitle/SubTitle';
import DiscoverCard, { DisoverCardProps } from './DiscoverCard';

import brighton from './../../assets/images/discover/brighton.webp';
import cambridge from './../../assets/images/discover/cambridge.webp';
import edinburgh from './../../assets/images/discover/Edinburg.webp';
import manchester from './../../assets/images/discover/Manchseter.webp';
import liverpool from './../../assets/images/discover/liverpool.webp';
import oxford from './../../assets/images/discover/Oxford.webp';
import boston from './../../assets/images/discover/Boston.webp';
import chicago from './../../assets/images/discover/Chicago.webp';
import losAngeles from './../../assets/images/discover/LosAngeles.webp';
import newYork from './../../assets/images/discover/NewYork.webp';
import vancouver from './../../assets/images/discover/Vancouver.webp';
import washingtonDC from './../../assets/images/discover/WashingtonDC.webp';

import montrealToQuebec from './../../assets/images/discover/MontrealToQuebec.webp';
import ottawaToToronto from './../../assets/images/discover/OttawaToToronto.webp';
import torontoToMontreal from './../../assets/images/discover/TorontoToMontreal.webp';
import torontoToNiagaraFalls from './../../assets/images/discover/TorontoToNiagaraFalls.webp';
import vancouverToJasper from './../../assets/images/discover/VancouverToJasper.webp';
import vancouverToToronto from './../../assets/images/discover/VancouverToToronto.webp';

import londonToParis from './../../assets/images/discover/LondonToParis.webp';
import parisToAmsterdam from './../../assets/images/discover/ParisToAmsterdam.webp';
import parisToBarcelona from './../../assets/images/discover/ParisToBarcelona.webp';
import parisToLyon from './../../assets/images/discover/ParisToLyon.webp';
import parisToGeneva from './../../assets/images/discover/ParisToGeneva.webp';
import parisToNice from './../../assets/images/discover/ParisToNice.webp';

import florenceToMilan from './../../assets/images/discover/FlorenceToMilan.webp';
import milanToRome from './../../assets/images/discover/MilanToRome.webp';
import naplesToRome from './../../assets/images/discover/NaplesToRome.webp';
import pisaToFlorence from './../../assets/images/discover/PisaToFlorence.webp';
import romeToVenice from './../../assets/images/discover/RomeToVenice.webp';
import veniceToMilan from './../../assets/images/discover/VeniceToMilan.webp';

import { Urls } from '../../context/Urls';
import axios from 'axios';
import { setSelectedArrivalStation, setSelectedDestinationStation } from '../../redux/actions/pointToPointActions';
import { setPopularJourneys } from '../../redux/actions/commonActions';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Carousel } from 'react-bootstrap';
import { ApplicationProviderRouteEnum } from '../../shared/enums/application-enum';
import {  FILTERING_COUNTRIES } from "../../common/constants";


export type PopularJourneys = { page: string, dataSet: DisoverCardProps[] }

const DiscoverSection = () => {

  const ukDataSet: DisoverCardProps[] = [
    {
      image: edinburgh,
      showFrom: 'London',
      from: 'London (All Stations)',
      showTo: 'Edinburgh (Waverley)',
      to: 'Edinburgh (Waverley)',
    },
    {
      image: oxford,
      showFrom: 'London',
      from: 'London (All Stations)',
      showTo: 'Oxford',
      to: 'Oxford',
    },
    {
      image: manchester,
      showFrom: 'London',
      from: 'London (All Stations)',
      to: 'Manchester (All Stations)',
      showTo: 'Manchester',
    },
    {
      image: liverpool,
      showFrom: 'London',
      from: 'London (All Stations)',
      to: 'Liverpool (All Stations)',
      showTo: 'Liverpool',
    },
    {
      image: brighton,
      showFrom: 'London',
      from: 'London (All Stations)',
      to: 'Brighton',
      showTo: 'Brighton',
    },
    {
      image: cambridge,
      showFrom: 'London',
      from: 'London (All Stations)',
      to: 'Cambridge',
      showTo: 'Cambridge',
    },
  ];

  const usaDataSet: DisoverCardProps[] = [
    {
      image: newYork,
      showFrom: 'Boston',
      from: 'Boston (Back Bay Station), MA',
      showTo: 'New York',
      to: 'New York, NY'
    },
    {
      image: boston,
      from: 'New York, NY',
      showFrom: 'New York',
      showTo: 'Boston',
      to: 'Boston (Back Bay Station), MA',
    },
    {
      image: washingtonDC,
      from: 'New York, NY',
      showFrom: 'New York',
      showTo: 'Washington',
      to: 'Washington, DC'
    },
    {
      image: vancouver,
      from: 'Seattle (King Street Station), WA',
      showFrom: 'Seattle',
      to: 'Vancouver, WA',
      showTo: 'Vancouver',
    },
    {
      image: losAngeles,
      showFrom: 'Los Angeles',
      from: 'Los Angeles, CA',
      showTo: 'San Diego',
      to: 'San Diego (Downtown), CA',
    },
    {
      image: chicago,
      from: 'Chicago (Union Station), IL',
      showFrom: 'Chicago',
      showTo: 'Seattle',
      to: 'Seattle (King Street Station), WA',
    },
  ];

  const canadaDataSet: DisoverCardProps[] = [
    {
      image: torontoToMontreal,
      showFrom: 'Toronto',
      from: 'Toronto, ON',   //CAYBZ
      showTo: 'Montreal',
      to: 'Montreal, QC' //CAYMY
    },
    {
      image: torontoToNiagaraFalls,
      showFrom: 'Toronto',
      from: 'Toronto, ON',   //CAYBZ
      showTo: 'Niagara Falls',
      to: 'Niagara Falls, ON', //CAXLV
    },
    {
      image: montrealToQuebec,
      from: 'Montreal, QC',
      showFrom: 'Montreal', //CAYMY
      to: 'Quebec, QC',
      showTo: 'Quebec', //CAXLJ
    },
    {
      image: vancouverToJasper,
      showFrom: 'Vancouver',
      from: 'Vancouver, BC', //CAXEA
      showTo: 'Jasper',
      to: 'Jasper, AB', //CAXDH
    },
    {
      image: vancouverToToronto,
      showFrom: 'Vancouver',
      from: 'Vancouver, BC', //CAXEA
      showTo: 'Toronto',
      to: 'Toronto, ON',  //CAYBZ
    },
    {
      image: ottawaToToronto,
      showFrom: 'Ottawa',
      from: 'Ottawa, ON', //CAXDS
      showTo: 'Toronto',
      to: 'Toronto, ON',  //CAYBZ
    },
  ];

  const franceDataSet: DisoverCardProps[] = [
    {
      image: londonToParis,
      showFrom: 'London',
      from: 'London St Pancras International',
      showTo: 'Paris',
      to: 'Paris (All Stations)' //FR#PA
    },
    {
      image: parisToAmsterdam,
      showFrom: 'Paris',
      from: 'Paris (All Stations)',
      showTo: 'Amsterdam',
      to: 'Amsterdam', //NL@AM
    },
    {
      image: parisToBarcelona,
      showFrom: 'Paris',
      from: 'Paris (All Stations)',
      to: 'Barcelona Sants',
      showTo: 'Barcelona', //ESBST
    },
    {
      image: parisToGeneva,
      showFrom: 'Paris',
      from: 'Paris (All Stations)',
      showTo: 'Geneva',
      to: 'Geneve (localite)', //FRTTX
    },
    {
      image: parisToLyon,
      showFrom: 'Paris',
      from: 'Paris (All Stations)',
      showTo: 'Lyon',
      to: 'LYON',  //FR#LY
    },
    {
      image: parisToNice,
      showFrom: 'Paris',
      from: 'Paris (All Stations)',
      showTo: 'Nice',
      to: 'Nice',  //FRNCE
    },
  ];
  const italyDataSet: DisoverCardProps[] = [
    {
      image: romeToVenice,
      showFrom: 'Rome',
      from: 'Rome',
      showTo: 'Venice',
      to: 'Venice'
    },
    {
      image: naplesToRome,
      showFrom: 'Naples',
      from: 'Naples Main Station',
      showTo: 'Rome',
      to: 'Rome',
    },
    {
      image: florenceToMilan,
      showFrom: 'Florence',
      from: 'Florence',
      to: 'Milan Main Station',
      showTo: 'Milan',
    },
    {
      image: veniceToMilan,
      showFrom: 'Venice',
      from: 'Venice',
      to: 'Milan Main Station',
      showTo: 'Milan',
    },
    {
      image: pisaToFlorence,
      showFrom: 'Pisa',
      from: 'Pisa Main Station',
      showTo: 'Florence',
      to: 'Florence',
    },
    {
      image: milanToRome,
      showFrom: 'Milan',
      from: 'Milan Main Station',
      showTo: 'Rome',
      to: 'Rome',
    },
  ];

  const dispatch = useAppDispatch();
  const browseFrom = useAppSelector((state) => state.common.browseFrom);
  const dataList = useAppSelector((state) => state.trainStations.trainStations);
  const savedPopularJourneys = useAppSelector((state) => state.common.popularJourneys);
  const [popularJourneysLocal, setPopularJourneysLocal] = useState<{ page: string, dataSet: DisoverCardProps[] }[]>([]
    // savedPopularJourneys && savedPopularJourneys.length > 0 ? savedPopularJourneys : [

    // ]
  );
  const [loadLoader, setLoadLoader] = useState(true);

  let currency = useAppSelector((state) => state.common.currency.value);

  useEffect(() => {
    if (!savedPopularJourneys || savedPopularJourneys.length === 0) {
      setLoadLoader(true)
      axios
        .get(Urls.APP_BASE_URL + "point-to-point/get-all-popular-journey")
        .then((res: any) => {
          const resData = res?.data?.body;
          const ukData = ukDataSet.map((item: any) => ({
            ...item,
            price: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.price,
            journeyTime: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.duration?.shortedDescription,
            provider: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.provider
          }));

          const usaData = usaDataSet.map((item: any) => ({
            ...item,
            price: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.price,
            journeyTime: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.duration?.shortedDescription,
            provider: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.provider
          }));

          const canadaData = canadaDataSet.map((item: any) => ({
            ...item,
            price: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.price,
            journeyTime: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.duration?.shortedDescription,
            provider: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.provider
          }));
          const franceData = franceDataSet.map((item: any) => ({
            ...item,
            price: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.price,
            journeyTime: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.duration?.shortedDescription,
            provider: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.provider
          }));
          const italyData = italyDataSet.map((item: any) => ({
            ...item,
            price: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.price,
            journeyTime: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.info?.duration?.shortedDescription,
            provider: resData.find((val: any) => (val.to?.text === item.to) && (val.from?.text === item.from))?.provider
          }));
//italy filter
          const hasItaly = FILTERING_COUNTRIES.find(item => item.text === 'Italy' && item.countryCode === 'IT');
          if (hasItaly) {
            setPopularJourneysLocal([
              {
                page: 'US',
                dataSet: usaData,
              },
              {
                page: 'UK',
                dataSet: ukData,
              },
              {
                page: 'CA',
                dataSet: canadaData,
              },
              {
                page: 'FR',
                dataSet: franceData,
              },
              {
                page: 'IT',
                dataSet: italyData,
              }
            ]);
            dispatch(setPopularJourneys([
              {
                page: 'US',
                dataSet: usaData,
              },
              {
                page: 'UK',
                dataSet: ukData,
              },
              {
                page: 'CA',
                dataSet: canadaData,
              },
              {
                page: 'FR',
                dataSet: franceData,
              },
              {
                page: 'IT',
                dataSet: italyData,
              }
            ]))
          } else {
            setPopularJourneysLocal([
              {
                page: 'US',
                dataSet: usaData,
              },
              {
                page: 'UK',
                dataSet: ukData,
              },
              {
                page: 'CA',
                dataSet: canadaData,
              },
              {
                page: 'FR',
                dataSet: franceData,
              },
              // {
              //   page: 'IT',
              //   dataSet: italyData,
              // }
            ]);
            dispatch(setPopularJourneys([
              {
                page: 'US',
                dataSet: usaData,
              },
              {
                page: 'UK',
                dataSet: ukData,
              },
              {
                page: 'CA',
                dataSet: canadaData,
              },
              {
                page: 'FR',
                dataSet: franceData,
              },
              // {
              //   page: 'IT',
              //   dataSet: italyData,
              // }
            ]))
          }
//original code
          // setPopularJourneysLocal([
          //   {
          //     page: 'US',
          //     dataSet: usaData,
          //   },
          //   {
          //     page: 'UK',
          //     dataSet: ukData,
          //   },
          //   {
          //     page: 'CA',
          //     dataSet: canadaData,
          //   },
          //   {
          //     page: 'FR',
          //     dataSet: franceData,
          //   },
          //   {
          //     page: 'IT',
          //     dataSet: italyData,
          //   }
          // ]);
          // dispatch(setPopularJourneys([
          //   {
          //     page: 'US',
          //     dataSet: usaData,
          //   },
          //   {
          //     page: 'UK',
          //     dataSet: ukData,
          //   },
          //   {
          //     page: 'CA',
          //     dataSet: canadaData,
          //   },
          //   {
          //     page: 'FR',
          //     dataSet: franceData,
          //   },
          //   {
          //     page: 'IT',
          //     dataSet: italyData,
          //   }
          // ]))
          setLoadLoader(false)
        }).catch((e) => {
          setLoadLoader(false)
        })
    } else {
      setLoadLoader(false)
    }
  }, [FILTERING_COUNTRIES]);

  useEffect(() => {
    if (savedPopularJourneys && savedPopularJourneys.length > 0) {
      if(browseFrom === ApplicationProviderRouteEnum.UK) {
        setPopularJourneysLocal(savedPopularJourneys.filter((x: any) => x.page === ApplicationProviderRouteEnum.UK.split("/")[1]));
      } else {
        setPopularJourneysLocal(savedPopularJourneys);
      }
    } else {

//Only italy filter
      const hasItaly = FILTERING_COUNTRIES.find(item => item.text === 'Italy' && item.countryCode === 'IT' );
      if (hasItaly) {
        setPopularJourneysLocal(
          browseFrom === ApplicationProviderRouteEnum.UK ?
            [
              {
                page: 'UK',
                dataSet: ukDataSet,
              },
            ] :
            [
              {
                page: 'US',
                dataSet: usaDataSet,
              },
              {
                page: 'UK',
                dataSet: ukDataSet,
              },
              {
                page: 'CA',
                dataSet: canadaDataSet,
              },
              // {
              //   page: 'FR',
              //   dataSet: franceDataSet,
              // },
              {
                page: 'IT',
                dataSet: italyDataSet,
              }
            ]);

      } else {

      setPopularJourneysLocal(
        browseFrom === ApplicationProviderRouteEnum.UK ?
          [
            {
              page: 'UK',
              dataSet: ukDataSet,
            },
          ] :
          [
            {
              page: 'US',
              dataSet: usaDataSet,
            },
            {
              page: 'UK',
              dataSet: ukDataSet,
            },
            {
              page: 'CA',
              dataSet: canadaDataSet,
            },
            // {
            //   page: 'FR',
            //   dataSet: franceDataSet,
            // },
            // {
            //   page: 'IT',
            //   dataSet: italyDataSet,
            // }
          ]);

      }

//Original code
      // setPopularJourneysLocal(
      //   browseFrom === ApplicationProviderRouteEnum.UK ?
      //     [
      //       {
      //         page: 'UK',
      //         dataSet: ukDataSet,
      //       },
      //     ] :
      //     [
      //       {
      //         page: 'US',
      //         dataSet: usaDataSet,
      //       },
      //       {
      //         page: 'UK',
      //         dataSet: ukDataSet,
      //       },
      //       {
      //         page: 'CA',
      //         dataSet: canadaDataSet,
      //       },
      //       {
      //         page: 'FR',
      //         dataSet: franceDataSet,
      //       },
      //       {
      //         page: 'IT',
      //         dataSet: italyDataSet,
      //       }
      //     ]);

    }
  }, [savedPopularJourneys,FILTERING_COUNTRIES])

  const handleSet = (to: any, from: any) => {
    const toStation = dataList.find((item: any) => item.text === to.toString())
    const fromStation = dataList.find((item: any) => item.text === from.toString())

    dispatch(setSelectedDestinationStation(fromStation));
    dispatch(setSelectedArrivalStation(toStation));
  }

  return (
    <>
      {
        <div className="discover-section">
          <div className="discover-section--content-area max-width">
            <DualColorDivider />
            <div className="mt-3 mb-5">
              <SubTitle>Where can we take you today?</SubTitle>
            </div>
            <Carousel indicators={false} controls={false} className="carousal" interval={5000}>
              {
                popularJourneysLocal.map((item) => (
                  <Carousel.Item key={item.page}>
                    <div className="row mb-100 w-100 ml-0 mr-0">
                      {
                        item.dataSet.map(({ image, from, to, price, showFrom, showTo, journeyTime }) => (
                          <div className="col-sm-12 col-md-6 col-lg-4 p-2" key={`${from}-${to}`}>
                            <DiscoverCard
                              loading={loadLoader}
                              image={image}
                              from={showFrom}
                              to={showTo}
                              price={price === '0.00' ? false : `${currency} ${price}`}
                              journeyTime={journeyTime}
                              handleSet={() => handleSet(to, from)}
                            />
                          </div>
                        ))
                      }
                    </div>
                  </Carousel.Item>
                ))
              }
            </Carousel>
          </div>
        </div>
      }
    </>
  );
}

export default DiscoverSection;


